export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpenEprofileVercsoport');
    },
    closeForm({commit}) {
        commit('setFormCloseEprofileVercsoport');
    }
}
